import { useMemo } from 'react';

import { useAppSelector } from '../state';
import { PluginType } from '../types/plugin';
import { ENpcStatusTrackText, getDialogModelChoice } from '../ui';
import { getNpcStatus } from '../ui/Home/NpcList';

export const EPluginTypeTrackText = {
  [PluginType.chat_image]: 'pic',
  [PluginType.search]: 'search',
  [PluginType.sing]: 'sing',
};

export function useEditPageTrack() {
  const { npcId, statusInfo, pluginList, settingInfo } = useAppSelector((state) => state.edit);
  const status = useMemo(() => getNpcStatus(statusInfo), [statusInfo]);

  const trackParams = useMemo(() => {
    return {
      npc_id: npcId,
      ugc_npc_approving_status: ENpcStatusTrackText[status],
      plugin_list: pluginList.map((p) => EPluginTypeTrackText[p.plugin_type]).join(','),
      dialog_model_choice: settingInfo.chat_model_type,
    };
  }, [npcId, status, pluginList, settingInfo.chat_model_type]);

  return {
    trackParams,
  };
}
